<template>
  <div class="gas-alarm-detector">
    <!-- Hero Section -->
    <section class="hero-section" :style="{backgroundImage: `url(${require('@/assets/bg2.png')})`}">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <div class="content-left">
            <h1 class="hero-title">气体报警仪检测</h1>
            <p class="hero-subtitle">专业检测服务，保障作业环境气体安全</p>
            <p class="hero-description">
              我们提供全面的气体报警仪检测服务，严格按照国家标准和行业规范，确保每<br />
              一台设备都能精准检测有害气体浓度并在危险发生前及时预警。
            </p>
            <button class="btn-primary">立即预约检测</button>
          </div>
          <div class="content-right">
            <div class="hero-image">
              <img src="@/assets/qitibaojingyi.png" alt="气体报警仪检测设备" />
              <div class="badge">
                <img src="@/assets/air-breathing/image-4.png" alt="图标" class="badge-icon" />
                <span>国家级检测资质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测流程 Section -->
    <section class="process-section">
      <div class="container">
        <h2 class="section-title">检测流程</h2>
        <div class="process-flow">
          <!-- 第一行 -->
          <div class="flow-row">
            <div class="flow-item">
              <div class="flow-number">01</div>
              <div class="flow-content">
                <h4>接受检验任务</h4>
                <p>受理委托，核对信息</p>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">02</div>
              <div class="flow-content">
                <h4>检验前准备</h4>
                <p>准备设备、标准气体</p>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">03</div>
              <div class="flow-content">
                <h4>结构与外观</h4>
                <p>检查部件完好性</p>
              </div>
            </div>
          </div>

          <!-- 连接箭头：从03到04 -->
          <div class="flow-connector right-to-right">
            <div class="connector-arrow">↓</div>
          </div>

          <!-- 第二行 -->
          <div class="flow-row reverse-desktop">
            <div class="flow-item">
              <div class="flow-number">06</div>
              <div class="flow-content">
                <h4>响应时间</h4>
                <p>测试响应速度</p>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">05</div>
              <div class="flow-content">
                <h4>示值误差</h4>
                <p>检测示值偏差</p>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">04</div>
              <div class="flow-content">
                <h4>标定</h4>
                <p>零点和量程标定</p>
              </div>
            </div>
          </div>

          <!-- 连接箭头：从06到07 -->
          <div class="flow-connector left-to-left">
            <div class="connector-arrow">↓</div>
          </div>

          <!-- 第三行 -->
          <div class="flow-row">
            <div class="flow-item">
              <div class="flow-number">07</div>
              <div class="flow-content">
                <h4>报警误差</h4>
                <p>验证报警功能</p>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">08</div>
              <div class="flow-content">
                <h4>重复性</h4>
                <p>检验测量稳定性</p>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item final">
              <div class="flow-number">09</div>
              <div class="flow-content">
                <h4>出具检验报告</h4>
                <p>生成证书和建议</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测标准 Section -->
    <section class="standard-section">
      <div class="container">
        <h2 class="section-title">检测标准</h2>
        <div class="standard-content">
          <div class="standard-card">
            <div class="standard-header">
              <i class="el-icon-document"></i>
              <h3>检验依据</h3>
            </div>
            <div class="standard-body">
              <p class="standard-text">GB 12358-2024《作业场所环境气体检测报警仪通用技术要求》</p>
            </div>
          </div>

          <div class="standard-card">
            <div class="standard-header">
              <i class="el-icon-info"></i>
              <h3>使用范围</h3>
            </div>
            <div class="standard-body">
              <p class="standard-text">适用于作业场所可燃气体、有毒有害气体、氧气检测报警仪器的检验。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'GasAlarmDetector',
  methods: {
    // 后续可以添加预约检测等方法
  }
}
</script>

<style scoped>
/* 基础容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  height: 470px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(30, 58, 138, 0.75) 0%, rgba(59, 130, 246, 0.45) 50%, rgba(255, 255, 255, 0.20) 100%);
  z-index: 1;
}

.hero-section > .container {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.content-left {
  flex: 1;
  max-width: 520px;
}

.content-right {
  flex: 1;
  display: none;
  justify-content: center;
  align-items: flex-start;
}

.hero-image {
  position: relative;
  width: 380px;
  height: 300px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0px 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.badge {
  position: absolute;
  bottom: -12px;
  right: -12px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  padding: 6px 14px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.badge-icon {
  width: 14px !important;
  height: 14px !important;
  object-fit: contain;
}

.badge span {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 38px;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 16px;
  line-height: 26px;
  color: #e0f2fe;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.hero-description {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 24px;
  color: #f0f9ff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(90deg, #1e40af 0%, #60a5fa 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
}

/* 检测流程 Section */
.process-section {
  padding: 40px 0;
  background: #f8f9fa;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
}

.process-flow {
  max-width: 1000px;
  margin: 0 auto;
}

.flow-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.flow-row.reverse {
  flex-direction: row-reverse;
}

.flow-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 14px 18px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  min-width: 240px;
}

.flow-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.flow-item.final {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
}

.flow-item.final .flow-number {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.flow-item.final .flow-content h4,
.flow-item.final .flow-content p {
  color: white;
}

.flow-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.flow-content {
  flex: 1;
}

.flow-content h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #2c3e50;
}

.flow-content p {
  font-size: 13px;
  color: #606266;
  margin: 0;
  line-height: 1.4;
}

.flow-arrow {
  font-size: 24px;
  color: #1e3a8a;
  font-weight: bold;
  flex-shrink: 0;
}

.flow-connector {
  display: flex;
  margin: 8px 0;
}

.flow-connector.right-to-right {
  justify-content: flex-end;
  padding-right: 120px;
}

.flow-connector.left-to-left {
  justify-content: flex-start;
  padding-left: 120px;
}

.connector-arrow {
  font-size: 28px;
  color: #1e3a8a;
  font-weight: bold;
}

/* 检测标准 Section */
.standard-section {
  padding: 40px 0;
  background: white;
}

.standard-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
}

.standard-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.standard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.standard-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1e3a8a;
}

.standard-header i {
  font-size: 28px;
  color: #1e3a8a;
}

.standard-header h3 {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.standard-body {
  padding: 0;
}

.standard-text {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2937;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 400px;
    padding: 80px 0 40px;
  }

  .hero-content {
    flex-direction: column;
    gap: 40px;
  }

  .content-left {
    max-width: 100%;
  }

  .content-right {
    width: 100%;
  }

  .hero-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 4/3;
  }

  .hero-title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .hero-description {
    font-size: 14px;
    line-height: 1.6;
    display: none;
  }

  .btn-primary {
    width: 100%;
    padding: 12px 24px;
  }

  .badge {
    bottom: -12px;
    right: -12px;
    padding: 6px 12px;
  }

  .badge span {
    font-size: 14px;
  }

  .badge-icon {
    width: 14px !important;
    height: 14px !important;
  }

  .section-title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .standard-section {
    padding: 40px 0;
  }

  .standard-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .standard-card {
    padding: 24px;
  }

  .standard-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  .standard-header i {
    font-size: 24px;
  }

  .standard-header h3 {
    font-size: 18px;
  }

  .standard-text {
    font-size: 15px;
    line-height: 1.6;
  }

  .process-section {
    padding: 40px 0;
  }

  .process-flow {
    padding: 0 15px;
    max-width: 100%;
  }

  .flow-row {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100%;
    align-items: stretch;
  }

  .flow-row.reverse-desktop {
    flex-direction: column-reverse !important;
  }

  .flow-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 8px 0;
    height: 24px;
    font-size: 0 !important;
  }

  .flow-arrow::after {
    content: '↓';
    font-size: 24px;
    color: #1890ff;
    line-height: 1;
  }

  .flow-connector {
    display: flex;
    justify-content: center !important;
    align-items: center;
    width: 100%;
    padding: 0 !important;
    margin: 8px 0;
    height: 24px;
  }

  .flow-connector.right-to-right,
  .flow-connector.left-to-left {
    justify-content: center !important;
    padding: 0 !important;
  }

  .connector-arrow {
    font-size: 24px;
    color: #1890ff;
    line-height: 1;
  }

  .flow-item {
    min-width: auto !important;
    width: 100%;
    max-width: 100%;
    padding: 12px 14px;
    gap: 10px;
    margin: 5px 0;
    box-sizing: border-box;
  }

  .flow-number {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .flow-content {
    flex: 1;
    min-width: 0;
  }

  .flow-content h4 {
    font-size: 14px;
    margin: 0;
  }

  .flow-content p {
    display: none;
  }

  .review-grid,
  .sample-grid {
    grid-template-columns: 1fr;
  }
}
</style>

